<template>
  <v-card>
    <v-card-title>
      <span class="title">{{titulo}}</span>
      <v-spacer></v-spacer>
      <v-btn
        small
        icon
        class="mr-3"
        v-if="puedoEditar()"
        @click="editar()"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text v-if="editando">
      <v-dialog
        v-model="editando"
        persistent
        max-width="400px"
      >
        <v-card class="modal-principal">
          <v-card-title>{{titulo}}</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="max-height: 400px;overflow-y:auto;">
            <v-alert
              v-model="alerta.mostrar"
              dismissible
              :type="alerta.tipo"
            >
              {{alerta.mensaje}}
            </v-alert>
            <v-container grid-list-lg>

              <v-layout
                row
                wrap
                align-center
              >
                <v-flex xs12>
                  <v-select
                    v-model="edicion.item.institucion_padre_id"
                    :items="combos.padres"
                    :item-text="this.$options.filters.nombreCentro"
                    :item-value="'id'"
                    label="Institucion"
                    v-validate="{required: true}"
                    :error-messages="errors.collect('item.institucion_padre_id')"
                    :data-vv-name="'item.institucion_padre_id'"
                    data-vv-validate-on="none"
                    @change="cambiarPadre"
                  ></v-select>
                </v-flex>
                <v-flex
                  xs12
                  v-show="combos.hijos.length > 1"
                >
                  <v-select
                    v-model="edicion.item.institucion_id"
                    :items="combos.hijos"
                    :item-text="'nombre'"
                    :item-value="'id'"
                    label="Institucion"
                    v-validate="{required: true}"
                    :error-messages="errors.collect('item.institucion_id')"
                    :data-vv-name="'item.institucion_id'"
                    data-vv-validate-on="none"
                  ></v-select>
                </v-flex>
              </v-layout>

            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <botones-cancelar-guardar
              v-bind:guardando="guardando"
              v-on:alGuardar="guardar"
              v-on:alCancelar="cerrar"
            ></botones-cancelar-guardar>

          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
    <v-card-text>
      <v-list dense>
        <v-list-tile
          v-for="item in items"
          :key="item.id"
          avatar
        >

          <v-list-tile-content>
            <v-list-tile-title>{{item.institucion | nombreCentro}}</v-list-tile-title>

          </v-list-tile-content>
          <v-list-tile-action v-if="puedoEditar()">
            <v-menu
              bottom
              left
              fixed
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  flat
                  icon
                  v-on="on"
                >
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list>

                <v-list-tile
                  v-for="(accion,key) in acciones"
                  :key="key"
                  :disabled="accionDesactivada(accion.key,item)"
                  @click="accionEnItem(item,accion.key)"
                >
                  <v-list-tile-action style="min-width:30px;">
                    <v-icon small>{{accion.icono}}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>{{accion.titulo}}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>

          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import mixinseccionModulo from '@/mixins/seccionModulo'
import Combo from '@/api/combo'
import _ from 'lodash'
import { nombreCentro } from '@/helpers/filtros'

export default {
  name: 'VUsuarioIntituciones',
  $_veeValidate: {
    validator: 'new'
  },
  mixins: [mixinseccionModulo],
  filters: {
    nombreCentro
  },
  computed: {
    items () {
      return this.$store.getters['detalleUsuario/usuarioSeleccionado'] ? this.$store.getters['detalleUsuario/usuarioSeleccionado'].instituciones : []
    }
  },
  data () {
    return {
      moduloStore: 'detalleUsuario',
      titulo: 'Instituciones',
      seccion: 'institucion',
      requerido: true,
      combos: {
        padres: [],
        hijos: []
      },
      acciones: [
        { key: 'editar', icono: 'edit', titulo: 'Editar' },
        { key: 'borrar', icono: 'delete', titulo: 'Borrar' }
      ]
    }
  },
  methods: {

    nuevoItem () {
      return {
        id: 0,
        usuario_id: this.$store.getters['detalleUsuario/usuarioSeleccionado'].id,
        institucion_padre_id: null,
        institucion_id: null,
        principal: false
      }
    },

    prepararEdicion () {
      let vm = this

      let dataCombos = {
        instituciones: {
          itemVacio: true,
          agruparHijos: true
        }
      }

      vm.combos.hijos.lenght = 0
      vm.combos.hijos = []

      if (vm.edicion.item.id === 0) {
        dataCombos.instituciones.noAsignadas = this.$store.getters['detalleUsuario/usuarioSeleccionado'].id
      }

      return Combo.listado(dataCombos).then(
        data => {
          vm.llenarCombos(data)

          if (vm.edicion.item.id > 0) {
            if (vm.edicion.item.institucion.padre_id > 0) {
              vm.edicion.item.institucion_padre_id = vm.edicion.item.institucion.padre_id
            } else {
              vm.edicion.item.institucion_padre_id = _.clone(vm.edicion.item.institucion_id)
            }

            vm.cambiarPadre()
            vm.edicion.item.institucion_id = _.clone(vm.edicion.item.institucion.id)
          }

          vm.cargando = false
          Promise.resolve()
        },
        error => {
          vm.mostrarError(error)
          vm.soloLectura = true
          vm.cargando = false
          Promise.reject(error)
        }
      )
    },

    llenarCombos (data) {
      let vm = this

      vm.combos.padres = data.instituciones
    },

    cambiarPadre () {
      let vm = this
      let hijos = []

      vm.combos.hijos.lenght = 0
      vm.combos.hijos = []

      if (vm.edicion.item.institucion_padre_id) {
        let padre = _.find(vm.combos.padres, { 'id': vm.edicion.item.institucion_padre_id })

        hijos.push({ id: vm.edicion.item.institucion_padre_id, nombre: 'Todos' })

        if (padre) {
          _.forEach(padre.hijos, function (value) {
            hijos.push({
              id: value.id,
              nombre: vm.$options.filters.nombreCentro(value)
            })
          })
        }

        vm.combos.hijos = _.assign(hijos)

        vm.edicion.item.institucion_id = vm.edicion.item.institucion_padre_id
      }
    },

    alGuardar (nuevoItem) {
      this.$store.commit('setearInstituciones', {
        instituciones: nuevoItem.instituciones,
        instituciones_ids: nuevoItem.instituciones_ids
      })
    }

  }

}
</script>

<style lang="scss" scoped>
</style>
